import { getUuid } from '@root/_models';
import { mergeAttributes, Node } from '@tiptap/core'
import { Node as ProseMirrorNode } from 'prosemirror-model';

export interface ImageOptions {
    HTMLAttributes: Record<string, any>,
    renderLabel: (props: {
        options: ImageOptions,
        node: ProseMirrorNode,
    }) => string,
    cmpRef: any,
    onDestroy: (options: ImageOptions) => void,
}

export interface SetImageOptions {
    fileId?: string
}

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        image: {
            setImage: (options: SetImageOptions) => ReturnType
        }
    }
}

export const VzImage = Node.create<ImageOptions>({
    name: 'image',

    addOptions() {
        return {
            HTMLAttributes: {},
            renderLabel: () => '',
            onDestroy() {},
            cmpRef: {}
        };
    },
    group: 'block',
    inline: false,
    selectable: false,
    draggable: false,

    addAttributes() {
        return {
            fileId: {
                default: null,
                parseHTML: element => element.getAttribute('data-fileid'),
                renderHTML: attributes => attributes.fileId ? { 'data-fileid': attributes.fileId } : {}
            },
            sid: {
                default: null,
                parseHTML:  element => element.getAttribute('data-sid') || getUuid().substring(0, 8),
                rendered: false,
            }
        }
    },

    parseHTML() {
        return [
            {
                tag: `div[data-type="${this.name}"]`
            },
        ];
    },

    renderHTML({ node, HTMLAttributes }) {
        return [
            'div',
            mergeAttributes({ 'data-type': this.name }, this.options.HTMLAttributes, HTMLAttributes),
            this.options.renderLabel({
                options: this.options,
                node,
            }),
        ];
    },

    addCommands() {
        return {
            setImage:
                options =>
                    ({ commands }) => {
                        return commands.insertContent({
                            type: this.name,
                            attrs: options,
                        })
                    },
        };
    },

    onDestroy() {
        this.options.onDestroy(this.options);
    }

});
